import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';
import { AdfNode } from './AdfNode';

export const AdfPanel = React.memo(({ node }: AdfNodeProps) => {
    const panelType = node.attrs?.panelType || 'info';

    return <div className={`panel ${panelType}`}>
        {node.content?.map((x, i) => <AdfNode key={i} node={x} />)}
    </div>;
});
